module.exports = __webpack_public_path__ + "dbd668a3941cb515f57f19a16bd31011.svg";